var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsOutlineCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5938 31.0625L60.5561 17.1001C61.9538 15.7024 64.3438 16.6923 64.3438 18.669V52.331C64.3438 54.3077 61.9538 55.2976 60.5561 53.8999L46.5938 39.9375M13.3125 55.4688H39.9375C43.6136 55.4688 46.5938 52.4886 46.5938 48.8125V22.1875C46.5938 18.5114 43.6136 15.5312 39.9375 15.5312H13.3125C9.63635 15.5312 6.65625 18.5114 6.65625 22.1875V48.8125C6.65625 52.4886 9.63636 55.4688 13.3125 55.4688Z",
    stroke: "#FBBC55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsOutlineCamera);
export default __webpack_public_path__ + "static/media/es_outline_camera.01f2781ec5d91d07e06ed9b9241f3f60.svg";
export { ForwardRef as ReactComponent };